import { useContext } from "react";
import { ArrowLeft } from "react-bootstrap-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { ROUTE_DASHBOARD } from "@constants/routes";
import Branding from "./Branding";

const BIG_ICON_SIZE = 16;

function Header() {
  const user = useContext(AuthContext);
  const navigate = useNavigate();

  return (
    <header className="border-b border-gray-200 bg-white shadow-sm">
      <div className="flex h-16 items-center justify-between px-6">
        {/* Logo */}
        <Link to="/" className="text-gray-900 transition-colors hover:text-gray-700">
          <Branding />
        </Link>

        {/* Navigation */}
        {user && user.emailVerified && (
          <nav className="flex items-center space-x-3">
            <button
              onClick={() => navigate(ROUTE_DASHBOARD)}
              className="flex items-center space-x-2 rounded-lg bg-gray-50 px-4 py-2.5 text-sm font-medium text-gray-700 transition-all duration-200 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              <ArrowLeft size={BIG_ICON_SIZE} />
              <span>Back to Dashboard</span>
            </button>
          </nav>
        )}
      </div>
    </header>
  );
}

export default Header;
